import React from 'react';
import Header from './Header';
import Footer from './Footer';
import WhatsAppCTA from './WhatsAppCTA';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppCTA />
    </div>
  );
};

export default Layout;